import { Component, Input, AfterViewInit, OnDestroy, inject, ViewChild, ElementRef, OnChanges, NgZone } from '@angular/core';
import { SnapshotModel } from '../../models';
import { WindowService } from '@shared/window';
import { Pagination } from 'swiper/modules';
import Swiper from 'swiper';
import { RouterLink } from '@angular/router';
import { TranslatePipe } from '@ngx-translate/core';

@Component({
    selector: 'app-example-products',
    templateUrl: './example-products.component.html',
    styleUrls: ['./example-products.component.scss'],
    imports: [RouterLink, TranslatePipe],
})
export class ExampleProductsComponent implements AfterViewInit, OnDestroy, OnChanges {
    private zone = inject(NgZone);
    private windowService = inject(WindowService);

    @ViewChild('swiper') swiperRef!: ElementRef<HTMLDivElement>;
    @ViewChild('swiperPagination') swiperPaginationRef!: ElementRef<HTMLDivElement>;
    @Input({ required: true }) snapshots!: SnapshotModel[];

    readonly isClient = this.windowService.isClient;

    private swiper?: Swiper;

    ngAfterViewInit() {
        if (this.windowService.isBrowser) {
            this.initSwiper();
        }
    }

    ngOnDestroy(): void {
        this.swiper?.destroy();
    }

    ngOnChanges(): void {
        this.swiper?.update();
    }

    private initSwiper() {
        this.zone.runOutsideAngular(() => {
            this.swiper = new Swiper(this.swiperRef.nativeElement, {
                modules: [Pagination],
                spaceBetween: 26,
                pagination: {
                    el: this.swiperPaginationRef.nativeElement,
                    type: 'bullets',
                },
                watchOverflow: true,
                observer: true,
                observeParents: true,
                observeSlideChildren: true,
                breakpoints: {
                    0: {
                        slidesPerView: 'auto',
                    },
                    370: {
                        slidesPerView: 1.5,
                        spaceBetween: 26,
                    },
                    768: {
                        slidesPerView: 3,
                        spaceBetween: 26,
                    },
                    1000: {
                        slidesPerView: 3,
                        spaceBetween: 26,
                    },
                    1200: {
                        slidesPerView: 6,
                        spaceBetween: 10,
                    },
                },
                threshold: 5,
            });
        });
    }
}
